var map = {
	"./en/3-1/rewards.png": 327,
	"./fi/3-1/rewards.png": 31073,
	"./in/3-1/rewards.png": 28019,
	"./th/3-1/rewards.png": 40286,
	"./tw/3-1/rewards.png": 80753,
	"./zh/3-1/rewards.png": 6920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68667;